export default __webpack_public_path__ + "static/media/F1_2.aad33aa6.png";